import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fd3d166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-total" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " You total ", -1))
const _hoisted_3 = { class: "product-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "product" }, " Product "),
  /*#__PURE__*/_createElementVNode("div", { class: "quantity" }, " Qty "),
  /*#__PURE__*/_createElementVNode("div", { class: "total" }, " Total ")
], -1))
const _hoisted_5 = { class: "product-list" }
const _hoisted_6 = { class: "product" }
const _hoisted_7 = { class: "product-title" }
const _hoisted_8 = { class: "product-desc type" }
const _hoisted_9 = { class: "quantity" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Subtotal:", -1))
const _hoisted_13 = { class: "money" }

import { CheckoutStore } from '@/stores';

  interface IProps {
    store: CheckoutStore;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    store: null
  },
  setup(__props: any) {

  


return (_ctx: any,_cache: any) => {
  const _component_AppPrice = _resolveComponent("AppPrice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.store.order.line_items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.product_name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option_types, (optionType) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: optionType.name,
                  class: "product-desc"
                }, _toDisplayString(optionType.name) + ": " + _toDisplayString(optionType.value), 1))
              }), 128)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.purchase_kind), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.quantity), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_AppPrice, {
                value: item.price
              }, null, 8, ["value"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_AppPrice, {
            value: __props.store.order.total
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})